import { types } from './accountBloggerTypes';

export const getInstagramList = payload => ({
  type: types.UPDATE_ACCOUNT_LIST,
  payload,
});
